
    import Vue from 'vue';
    import Scroll  from 'components/plugin/scroll'
    import encrypt from 'components/plugin/lib/encrypt.js'
    import AvatarCropper from "vue-avatar-cropper"
    import animate from 'animate.css'
    import http from '@/utils/http-interceptor'

    Vue.filter('amount_convert',function(val){
        return (val/100).toFixed(2)
    })

    export default {
        components: {
            Scroll,
            AvatarCropper
        },
        data () {
            return {
                loading: 0,
                apiStatus: true,
                bottom: 0,
                apiData: {
                    keyword: '',
                    pageNum: 20,
                    circleId: '',
                },
                data: null,
                shopInfoList: [],
                marketPageQueryVO: [],
                errorText: '输入商家名称进行搜索',
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                //当用户不存在或ddtoken不存在时return
                if(!to.query.circleId) return;
                vm.apiData.circleId = to.query.circleId;
                vm.apiData.userId = to.query.userId;
                // 从列表页面返回后自动搜索
                if (to.query.keyword && to.query.keyword != '') {
                    vm.loading = 1;
                    vm.apiData.keyword = to.query.keyword;
                    vm.circleId
                    vm.getShopList();
                }
            })
        },
        mounted () {
        
            // this.getShopList();
        },
        methods: {

            // 搜索商家
            getShopList (type) {
                if (this.apiStatus) {
                    this.apiStatus = false;
                }

                this.loading = 1;
                http.get('/circle2/v2/shop/searchByCircle', {
                    params: encrypt(this.apiData)
                }).then(res => {

                    this.apiStatus = true;
                    this.data = res.data.data;
                    var shopInfoList = res.data.data.shopPageQueryVO.shopInfoList;
                    var marketPageQueryVO = res.data.data.marketPageQueryVO.marketListVOS;
                    if (marketPageQueryVO.length > 0) {
                        this.marketPageQueryVO = marketPageQueryVO;
                    }
                    if (shopInfoList.length > 0) {
                        if (type == 'add' && this.shopInfoList.length > 0) {
                            this.shopInfoList = [...this.shopInfoList,...shopInfoList];
                        } else {
                            this.shopInfoList = shopInfoList;
                        }

                        if (shopInfoList.length >= 20) {
                            this.lastRowId = changeList[changeList.length - 1].rowId
                        } else {
                            this.bottom = 1;
                        }

                        this.loading = 0;
                        return
                    } else {
                        this.loading = 0;
                        this.bottom = 1;
                    }
                    if (marketPageQueryVO.length == 0 && shopInfoList.length == 0) {
                        this.errorText = '没有相关商家/商场';
                        setTimeout(()=>{
                            this.errorText = '输入商家名称进行搜索';

                        }, 2000);
                    }

                })
            },
            onBottom () {
                //第一页都不够的话，直接不去加载
                if(this.shopInfoList.length < 20 || this.bottom){
                    this.bottom = 1;
                    return
                }
                
                if(!this.loading){
                    this.getShopList('add');
                }
            },
            // 选择结果
            selectShop (shopId, shopName, isEcomShop) {
                var relationType = isEcomShop;
                if (isEcomShop == 0) {
                    relationType = '2';
                }
                var data = {
                    relationId: shopId,
                    relationName: shopName,
                    relationType: relationType
                };
                sessionStorage.setItem('relationData', '');
                sessionStorage.setItem('relationData', JSON.stringify(data));
                this.goSceneCreate();
            },
            // 返回创建现场页面
            goSceneCreate(){
                var queryData = this.apiData;
                this.$router.push({
                    name:'sceneCreate',
                    query: queryData
                })
            },
            // 店家进入商家列表
            goListPage (type) {
                var queryData = this.apiData;
                queryData.type = type;
                this.$router.push({
                    name: 'SearchList',
                    query: queryData
                })
            }


        }

    }


// WEBPACK FOOTER //
// ./src/components/page/scene/shopSearch/search.js